"use client";
import Button from "@/components/ui/button";
import Title from "@/components/ui/Title";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

type Props = {};

export default function Cta({}: Props) {
  const [email, setEmail] = useState("");

  return (
    <>
      <main className=" w-full relative md:my-20 my-8 rounded-xl md:h-[60vh] h-[40vh] mx-auto  overflow-hidden border-2 border-primary2">
        <figure className="h-full">
          <Image
            src="/cta.jpeg"
            alt=""
            width={5000}
            height={5000}
            className="object-cover object-center h-full"
          ></Image>
          <div className="absolute bg-gradient-to-t from-black via-black/60 to-transparent inset-0 h-full w-full"></div>
        </figure>
        <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 text-white">
          <div>
            <h2 className="lg:text-6xl whitespace-nowrap md:text-4xl sm:text-3xl text-xl text-center uppercase title tracking-wider  font-extrabold ">
              Travel Beyond Limit
            </h2>
            <p className="mt-2 w-[70%] mx-auto sm:text-[18px] leading-tight desc py-4 text-xs font-medium  text-center  ">
              Get PDF before flying Nepal Experience the world class tour
              package at the best rate.
            </p>
          </div>

        

          <Link href="/partner" className="flex justify-center">
            <button className="md:px-6 md:py-3 px-3 py-2 rounded-md bg-primary2 hover:bg-orange-800 duration-200 ease-in-out font-semibold text-xs md:text-base">
              Become Partner with us
            </button>
          </Link>
        </div>
      </main>
    </>
  );
}
